import { DraggedSingleData } from "../../../../components/ui/DragToolsUI";
import { HudActions } from "../../../../components/ui/hud/HUDUI";
import BaseScenarioPart from "../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { constants } from "../../../../misc/constants";
import { globals } from "../../../../misc/globals";
import { DaarcBaseScenario } from "../../../DaarcBaseScenario";
import GeneralNeutralStateMain, { GeneralNeutralStatePart4Config, GeneralNeutralStateMainConfig } from "../GeneralNeutralStateMain";


export default class GeneralNeutralStatePart4 extends BaseScenarioPart<DaarcBaseScenario> {
	private alreadyDone = false;
	private get config(): GeneralNeutralStatePart4Config {
		return this.scenarioConfig.part4Config;
	}
	constructor(private main: GeneralNeutralStateMain, private _scenario: DaarcBaseScenario, private onDone: () => void, private id: string, private scenarioConfig: GeneralNeutralStateMainConfig) {
		super(_scenario);
	}

	public get partId(): string {
		return this.id;
	}

	public get videoUrl(): string[] {
		return [this.config.videoUrl];
	}

	public start() {
		const context = this;
		context._scenario.currentTaskMessage = 'Please adjust head of bed';
		context._scenario.uiWrapper.displayHUD({
			score: context._scenario.totalScore,
			maxScore: this._scenario.maxScore,
			onActionClicked: (actionType: HudActions, personIconDown: string, title: string) => {
				if(context.main.onHudActionClicked(actionType, personIconDown, title)) {
					return true;
				}
				switch(actionType) {
					case HudActions.AdjustBedHeight:
						context.adjustBedHeight(title);
						return true;
					default:
						if(context.config.onSettingUpAnythingElse) {
							context.config.onSettingUpAnythingElse();
						}
						context._scenario.adjustBedHeightPoints = 250;
						context._scenario.displayMessage(context._scenario.currentTaskMessage);
						return false;
				}
			}
		}, context._scenario.hudId);

		if(!context.main.config.isEmanuelMcKenzie) {
			context.scenario.toolbagId = context._scenario.uiWrapper.displayToolbag({
				onToolClicked: (data: DraggedSingleData) => {
					context._scenario.displayMessage(context.scenarioConfig.isTestScenario ? context.main.toolsMessageTestScenario : context._scenario.currentTaskMessage);
					context._scenario.adjustBedHeightPoints = 250;
				}
			}, context._scenario.toolbagId);
		}
	}

	public adjustBedHeight(title: string) {
		const context = this;
		if(!context.alreadyDone) {
			context._scenario.addScore(context._scenario.adjustBedHeightPoints);
			context.alreadyDone = true;
		}
		var onDoneWithPopup = context._scenario.doSomething('Raising head of bed and removing headboard');
		if(context.config.onAdjustedBedHeight) {
			context.config.onAdjustedBedHeight();
		}
		// context.scenario.debriefLog('Adjusted bed height');
		var suffix = 'PH';
		switch(title) {
			case 'respiratoryTherapist':
				suffix = 'RT';
				break;
			case 'nurse':
				suffix = 'RN';
				break;
		}
		
		context.main.loopVideo(this, context.config.waitForAdjustBedHeightVideoChapter());

		setTimeout(() => {
			onDoneWithPopup();
			context.scenario.gameManager.SoundManager.playSound({
				src: './assets/audio/hud/BedHeightNPCResponse_' + suffix + '.mp3',
				autoPlay: true,
				enableClosedCaptioning: false,
				muted: globals.isMuted,
				volume: 1
			});
			context.onDone();
		}, constants.doSomethingTimeout);
	}
}